import { Injectable } from '@angular/core';
import { PageableDatasource } from '../../../shared/contract/pageable-datasource.contract';
import { SearchUsersRequest } from '../contract/requests/search-users-request.contract';
import { SearchUser } from '../contract/search-user.contract';
import { UserListConfigService } from './user-list-config.service';
import { UsersApiService } from './users-api.service';

@Injectable({ providedIn: 'root' })
export class UsersDatasourceService extends PageableDatasource<SearchUser> {
  readonly contentEmitters = this.listConfigService.contentEmitters;

  constructor(
    private listConfigService: UserListConfigService,
    private usersApiService: UsersApiService,
  ) {
    super();
    super.changePageSize(this.listConfigService.pageSize, false);
  }

  public requestData(params: SearchUsersRequest): void {
    this.usersApiService.searchUsers(params).subscribe((resp) => {
      this.setPageableData(resp);
    });
  }

  public requestDataCrossOrganisation(params: SearchUsersRequest): void {
    this.usersApiService.getUsersCrossOrganisation(params).subscribe((resp) => {
      this.setPageableData(resp);
    });
  }

  override changePageSize(size: number, update = true): void {
    this.listConfigService.savePageSize(size);
    super.changePageSize(size, update);
  }
}
